import React from 'react';
import OverWindow from '../../Elements/TabList/OverWindow';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import { statusPillClass } from './homeHelpers';
import FigmaBadge from '../../Elements/FigmaBadge';

function DevelopmentNewsDetail({ item = null, onClose = () => {} }) {
  if (!item) return null;

  const isReleased = item.isReleased && item.isReleased();
  const dateLabel = isReleased ? 'Released' : 'Planned Release';
  const dateValue = isReleased ? item.StatusCategoryChangeDate : item.TargetDate;
  const dateText = dateValue ? dateTimeHelper.toYYYYsMMsDD(dateValue) : '—';

  return (
    <OverWindow
      title={item.BravoTitle}
      clickOnCancel={onClose}
      className='top-of-boxFigma dn-overwindow'
      maxWidth={620}
      minHeight='auto'
    >
      <div className='bravo-ds dn-detail'>
        <div className='dn-row'>
          <span className='dn-k'>Ticket</span>
          <span className='dn-v'>{item.Key}</span>
        </div>
        <div className='dn-row'>
          <span className='dn-k'>Title</span>
          <span className='dn-v'>{item.BravoTitle}</span>
        </div>
        <div className='dn-row'>
          <span className='dn-k'>Status</span>
          <span className='dn-v'>
            <FigmaBadge
              variant={statusPillClass(item.StatusName)}
              label={item.StatusName}
            />
          </span>
        </div>
        <div className='dn-row'>
          <span className='dn-k'>Business owner</span>
          <span className='dn-v'>{item.BusinessOwner || '—'}</span>
        </div>
        <div className='dn-row'>
          <span className='dn-k'>{dateLabel}</span>
          <span className='dn-v'>
            <span className='rel-date'>{dateText}</span>
          </span>
        </div>
        {item.BravoDescription ? (
          <div className='dn-desc'>
            <h4>Description</h4>
            <p>{item.BravoDescription}</p>
          </div>
        ) : null}
      </div>
    </OverWindow>
  );
}

export default DevelopmentNewsDetail;
